// Canonical public site origin. Sourced from the build-time env so a domain
// change only requires updating VITE_PUBLIC_SITE_URL, not editing every page.
const rawSiteUrl =
  import.meta.env.VITE_PUBLIC_SITE_URL ?? "https://chatwithiris.com";

// Strip any trailing slash so callers can safely append paths.
export const SITE_URL: string = rawSiteUrl.replace(/\/+$/, "");

// Host without protocol, for visible link text (e.g. "chatwithiris.com").
export const SITE_HOST: string = SITE_URL.replace(/^https?:\/\//, "");

/** Build an absolute site URL for a given path (e.g. "/privacy"). */
export function siteUrl(path = ""): string {
  if (!path || path === "/") return SITE_URL;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
